import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService, ClientService } from '../../../../_services';
import { EditAdClient } from '../../../../_models/customers/client/EditAdClient';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ClientAutorisationStatus, takeEnumValue } from '../../../../_models/customers/client/ClientAutorisationStatus';
import { UserType } from '../../../../_models/users/UserType';
import { JwtToken } from "../../../../_services/users/JwtToken";
import { traductionsKeysEnum } from 'src/assets/i18n/traductionsKeysEnum';

@Component({
   selector: 'app-edit-client',
   templateUrl: './edit-client.component.html',
   styleUrls: ['./edit-client.component.scss']
})
export class EditClientComponent implements OnInit {
   type: string;
   user;
   preview: string;
   registerForm: UntypedFormGroup;
   submitted = false;
   userType = UserType;
   clientAutorisationStatus = ClientAutorisationStatus;
   logoName = '';
   commercial = false;

   constructor(
      private formBuilder: UntypedFormBuilder,
      private clientService: ClientService,
      private toastr: ToastrService,
      private authenticationService: AuthenticationService,
      public dialogRef: MatDialogRef<EditClientComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
   ) {
      this.user = data.client;
      this.preview = window.atob(this.user.logo);
   }

   ngOnInit(): void {
      this.type = this.authenticationService.userValue?.type;
      if (this.type === UserType.AGENT_COMMERCIAL) {
         this.commercial = true;
      }
      if (this.user.expert !== true) {
         this.user.expert = false;
      }
      this.registerForm = this.formBuilder.group({
            name: [this.user.name, [Validators.required, Validators.minLength(3), Validators.maxLength(50),
               Validators.pattern('^[a-zA-Z0-9 \\-\']+')]],
            companyName: [this.user.raisonSocial ?? ''],
            address1: [this.user.address1 ?? ''],
            address2: [this.user.address2 ?? ''],
            postalCode: [this.user.postalCode ?? ''],
            city: [this.user.city ?? ''],
            country: [this.user.country ?? ''],
            statut: [takeEnumValue(this.user.autorisationStatus)],
            level: [this.user.autorisationLevel],
            plannerId: [this.user.plannerId],
            logo: [null],
            crmId: [this.user.crmId],
            expert: [this.user.expert],

         }
      );

   }

   close() {
      this.dialogRef.close();
   }

   get f() {
      return this.registerForm.controls;
   }

   onSubmit() {
      this.submitted = true;
      if (this.registerForm.invalid) {
         return;
      }
      if (this.registerForm.value.logo) {
         this.logoName = this.registerForm.value.logo.name;
      } else this.logoName = this.user.logoName;
      const editAdClient: EditAdClient = {
         name: this.registerForm.value.name,
         siren: this.user.siren,
         siret: this.user.siret,
         logo: this.preview,
         logoName: this.logoName,
         autorisationLevel: this.registerForm.value.level,
         autorisationStatus: this.registerForm.value.statut,
         crmId: this.registerForm.value.crmId,
         plannerId: this.registerForm.value.plannerId,
         expert: this.registerForm.value.expert,
         raisonSocial: this.registerForm.value.companyName,
         address1: this.registerForm.value.address1,
         address2: this.registerForm.value.address2,
         postalCode: this.registerForm.value.postalCode,
         city: this.registerForm.value.city,
         country: this.registerForm.value.country,

      };

      this.clientService.editCustomer(editAdClient)
      .subscribe(
         () => {
            this.toastr.success('Le client a bien été modifié.', '', { timeOut: 7000 });
            this.dialogRef.close();
         },
         err => {
            this.toastr.error('err', err, { timeOut: 7000 });
            this.dialogRef.close();
         }
      );
   }

   uploadFile(event: Event) {
      const file = (event.target as HTMLInputElement).files[0];
      if (file.type.match('image.*')) {
         const size = file.size;
         if (size > 1000000) {
            alert('size must not exceeds 1 MB');
         } else {
            this.registerForm.patchValue({
               logo: file
            });
            this.registerForm.get('logo').updateValueAndValidity()

            // File Preview
            const reader = new FileReader();
            reader.onload = () => {
               this.preview = reader.result as string;
            }
            reader.readAsDataURL(file)
         }
      } else {
         alert('invalid format!');
      }
   }

    protected readonly traductionsKeysEnum = traductionsKeysEnum;
}
